import comp from "./SharedAvatarListPopover";
export default comp;
